export default {
  body: {
    id: 'vtest_payment_method_body_paypal',
    defaultMessage: 'Pay directly or pay in 4 with PayPal, free of charge.',
  },
}
